import { type CURRENCYCONFIGTYPE, getCurrencyProps } from 'BreetHelpers';
import { selectUserData, useAppSelector } from 'BreetRedux';

export const useUserCurrencyProps = (): CURRENCYCONFIGTYPE | undefined => {
	const user = useAppSelector(selectUserData);

	const currencyProps = getCurrencyProps(user);

	return currencyProps;
};
